module.exports = __webpack_public_path__ + "img/retrospect-44-mobile.f255803b.jpg";